<template>
	<Overlay
		ref="overlay"
		title="Loader"
		class="overlay--loader"
		:isShown="isShown"
		:show-header="false"
		:class="{
			'overlay--nested': nested,
			'overlay--opaque': opaque,
		}"
		:onCloseFromBg="noClose"
	>
		<template v-slot:body>
			Loading
		</template>
	</Overlay>
</template>

<script src="./Loader.js"></script>
